import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next"

/**
 * Composant pour afficher le nombres d'équipements...
 * @param {string} title - titre de la carte
 * @param {number} number - longueur du tableau à afficher
 * @param {string} logo - URL si vous souhaitez afficher une image
 * @param {string} color - couleur du logo
 * @param {string} stylesIcons - arrière-plan du logo
 */
export default function NumberCard({title, number, logo, color, stylesIcons, styleCard, image}) {
    const {t} = useTranslation();

    return (
        <div className={`card card-${styleCard}`}>
            {logo && stylesIcons && color &&
                <div className={`card-background-logo card-${stylesIcons}`}>
                    <FontAwesomeIcon icon={logo} color={color} />
                </div>
            }
            {image && (
                <img className="card-logo-image" src={image} alt={`Logo ${title}`} />
            )}
            <h2 className="card-title">
                {t(title)}
            </h2>
            <p className="card-number">{number}</p>
        </div>
    )
}